// Recolhimento de texto (<read-more>): o painel nasce inteiro no HTML e
// este elemento é que o encurta, então sem JS nada fica escondido.
// O botão só aparece quando o conteúdo realmente passa da altura, e some
// de novo quando a tela cresce e o recorte deixa de existir.

class ReadMore extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('[data-read-more-body]');
    this.toggle = this.querySelector('[data-read-more-toggle]');
    if (!this.body || !this.toggle) return;

    this.toggle.addEventListener('click', () => {
      this.toggleAttribute('open');
      this.measure();
    });

    this.setAttribute('data-enhanced', '');
    this.measure();

    // A altura de corte vem do CSS e muda com o viewport, então o
    // observador é quem decide se o botão ainda faz sentido.
    this.observer = new ResizeObserver(() => this.measure());
    this.observer.observe(this.body);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  measure() {
    const limit = parseFloat(getComputedStyle(this).getPropertyValue('--read-more-height'));
    // The cut is measured against the natural height: while collapsed,
    // scrollHeight already reports the whole content.
    const overflows = Number.isFinite(limit) && this.body.scrollHeight > limit + 1;
    // The CSS only cuts and fades when this attribute is on: a short text
    // stays whole, with no fade over it and no button.
    this.toggleAttribute('data-overflows', overflows);
    this.toggle.hidden = !overflows && !this.hasAttribute('open');
    if (!overflows && !this.hasAttribute('open')) this.removeAttribute('open');
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}
